import userPermissionsReducer from "./reducers";
export { default as userPermissionsTypes } from "./types";
export { default as userPermissionsOperations } from "./operations";
export default userPermissionsReducer;
